import Chip from "@Components/Decor/Chip";
import { NextArrowIcon } from "@Icons/MainIcons";
import Star from "@Icons/MainIcons/StarIcon";
import IconHolder from "../../../../../../components/Decor/IconHolder";
import Skewer from "../../../../../../components/Decor/Skewer";
import { FC, RefObject } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import "./index.css";
import Box from "@Icons/MainIcons/Box";
import LandingHeroDecor from "./LandingHeroDecor";

const LandingHeroDecorComponent = withConditionalComponent(LandingHeroDecor, () => null);

const LandingHero: FC<{ contentRef: RefObject<HTMLElement> }> = ({ contentRef }) => {
  const { t } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint().lg;

  return (
    <section className="relative w-full overflow-hidden px-4 flex h-full items-center justify-center">
      <svg className="landing-hero-mesh landing-hero-mesh-scroll text-border-subtle pointer-events-none absolute inset-0 h-full w-full" aria-hidden>
        <defs>
          <pattern id="landing-hero-box-mesh" width={80} height={80} patternUnits="userSpaceOnUse">
            <Box width={80} height={80} viewBox="0 0 5 5" fill="none" strokeWidth={.1} className="text-font-disabled"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#landing-hero-box-mesh)" />
      </svg>
      <LandingHeroDecorComponent trigger={isLargeScreen} />

      <div className="relative z-10 mx-auto flex flex-col items-center gap-7 text-center">
        <Chip title={t("Landing.hero.badge")} icon={<div className="bg-font-active aspect-square w-2 rounded-full" />} />

        <h1 className="font-poppins text-font-hover -mt-1 flex flex-col items-center gap-4 text-4xl leading-base font-bold md:text-8xl max-w-6xl rtl:md:text-7xl">
          <span>
            <Trans
              i18nKey="Landing.hero.titleLine1"
              components={{
                icon: (
                  <span className="mx-2 inline-block align-middle md:mx-4">
                    <IconHolder icon={<Star className="aspect-square w-8 p-1.5 md:w-18 md:p-4" />} />
                  </span>
                ),
              }}
            />
          </span>
          <span className="flex flex-wrap items-center justify-center gap-5">
            <Trans i18nKey="Landing.hero.titleLine2" components={{ highlight: <Skewer angle={-3} className="px-4 py-0.5!" /> }} />
          </span>
        </h1>

        <p className="text-font-subtle text-sm">{t("Landing.hero.subtitle")}</p>

        <button
          type="button"
          onClick={() => contentRef.current?.scrollIntoView({ behavior: "smooth", block: "start" })}
          className="bg-background-primary group shadow-action flex cursor-pointer items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold text-white transition-transform"
        >
          {t("Landing.hero.cta")}
          <NextArrowIcon className="h-3 w-4 animate-pulse group-hover:animate-none" />
        </button>

        <div className="text-font-subtle -mt-3 flex items-center gap-1 text-xs italic">
          <Star className="text-font-active h-3 w-3" />
          {t("Landing.hero.footnote")}
        </div>
      </div>
    </section>
  );
};

export default LandingHero;
